// extracted by mini-css-extract-plugin
export var breadcrumbIconContainer = "Breadcrumbs-module--breadcrumb-icon-container--5f933";
export var breadcrumbSection = "Breadcrumbs-module--breadcrumb-section--d41dd";
export var innerSection = "Breadcrumbs-module--inner-section--ce1db";
export var leftChevronContainer = "Breadcrumbs-module--left-chevron-container--af981";
export var oneLevelContainer = "Breadcrumbs-module--one-level-container--7e329";
export var twoLevelContainer = "Breadcrumbs-module--two-level-container--c410e";